import { render, staticRenderFns } from "./SoDialog.vue?vue&type=template&id=09e79bfe"
import script from "./SoDialog.vue?vue&type=script&lang=js"
export * from "./SoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports